import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/Navbar';
import './ServicePage.css';

const StaticWebsite = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
    window.scrollTo(0, 0);
  }, []);

  const features = [
    '1–10 pages static site',
    'High-quality responsive design',
    'SEO-friendly structure',
    'Fast loading speed',
    'Contact forms',
    'Google Analytics setup',
    'Lightning-fast hosting'
  ];

  const idealFor = [
    'Small businesses',
    'Personal brands',
    'Portfolios',
    'Landing pages',
    'Company profiles'
  ];

  return (
    <div className="service-page">
      <Navbar />
      <div className="service-hero">
        <Link to="/" className="back-button" data-aos="fade-right">
          <FaArrowLeft /> Back to Home
        </Link>
        <div className="service-hero-content" data-aos="fade-up">
          <h1 className="service-page-title">Static Website Development</h1>
          <p className="service-hero-tagline">Clean, fast, SEO-friendly static websites for your brand.</p>
        </div>
      </div>

      <div className="service-content">
        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Overview</h2>
          <p className="section-text">
            Perfect for portfolios, startups, and businesses that want a quick, professional online presence. 
            We build visually stunning static sites with excellent performance and SEO foundations.
          </p>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">What You Get</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-item" data-aos="fade-up" data-aos-delay={index * 50}>
                <FaCheck className="check-icon" />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Ideal For</h2>
          <div className="ideal-for-list">
            {idealFor.map((item, index) => (
              <div key={index} className="ideal-item" data-aos="fade-up" data-aos-delay={index * 100}>
                {item}
              </div>
            ))}
          </div>
        </div>

        <div className="service-cta" data-aos="fade-up">
          <Link to="/contact" className="cta-button-primary">
            Create My Website →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StaticWebsite;

